import { v4 as uuidv4 } from "uuid";
import { CONFIG } from "~/config";

interface IOphotoTimelineItem {
	mapset: string;
	source: string;
	label: string;
	layers: Array<string>;
	minzoom: number;
	maxzoom: number;
}

export interface IOphotoCopyrightItem {
	text: string;
	source: string;
	minzoom?: number;
	maxzoom?: number;
}

export interface IOphotoResponse<T> {
	date?: string;
	geom?: {
		type: string;
		data: T;
		minzoom: number;
		maxzoom: number;
	};
	source?: string;
	maxzoom?: number;
	timeline?: Array<IOphotoTimelineItem>;
	copyrights: Array<IOphotoCopyrightItem>;
	active?: {
		layers: Array<string>;
		mapset: string;
	}
}

const URL = "/ortophoto/v1/timeline";

export function getOphotoTimelineData(viewport: {
	lbx: number;
	lby: number;
	rtx: number;
	rty: number;
}, zoom: number, mapset?: string): Promise<IOphotoResponse<Array<string>>> {
	// eslint-disable-next-line no-async-promise-executor
	return new Promise(async (resolve, reject) => {
		const response = await fetch(`${CONFIG.requestUrl}${URL}?${new URLSearchParams({
			left: viewport.lbx.toString(),
			top: viewport.rty.toString(),
			right: viewport.rtx.toString(),
			bottom: viewport.lby.toString(),
			zoom: zoom.toString(),
			...mapset ? { mapset } : {},
		}).toString()}`, {
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				"X-Correlation-Id": uuidv4(),
			},
			credentials: "include",
		});

		if (response?.status === 200) {
			resolve(await response.json());
		} else {
			reject();
		}
	});
}
